import React from 'react';
import {Select} from 'antd';

import { FormFieldInputWrapperClasses, FormFieldWrapperClasses } from '../';
import { trb } from '@utilities';

const Option = Select.Option;

export class SelectSearchFormField extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            active: !this.props.input.value && this.props.input.value !== 0
            && !this.props.defaultValue && this.props.defaultValue !== 0 ? true : false,
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if ((this.props.input.value && this.props.input.value !== prevProps.input.value)
        || (this.props.defaultValue  && this.props.defaultValue !== prevProps.defaultValue)) this.setState({
            active: false,
        });
    }

    onBlur = (e) => {
        if (!this.props.input.value && this.props.input.value !== 0) this.setState({
            active: true
        });
        if (e) this.props.input.onBlur(e);
    }

    onSelect = (e) => {
        this.setState({
            active: false
        });
        if (e && typeof(this.props.onSelect) === 'function') this.props.onSelect(e);
    }

    onValueChange = (value) => {
        this.props.input.onChange(value);
    }

    onSearch = (value) => {
        this.setState({
            active: false,
        });
        if (typeof(this.props.onSearch) === 'function') this.props.onSearch(value);
    }

    onClear = () => {
        this.setState({
            active: true,
        });
    }

    render = () => {
        const {
            title,
            titleWithoutTranslate,
            className,
            classNameField,
            classNameTitle,
            classNameError,
            inline,
            placeholder,
            disabled,
            options,
            optionsLabel,
            optionsValue,
            translate,
            meta,
            small
        } = this.props,
        {active} = this.state;

        const checkOption = (value, input) => {
            const optionValue = options.find(e => e[optionsValue] === value);

            if (optionValue) {
                return value;
            } else {
                input.onChange(undefined);
            }
        };

        return <div className={FormFieldWrapperClasses(className, inline, disabled, active, small)}>
            {title && <div className={
                classNameTitle
                ? 'form-field-title ' + classNameTitle
                : inline
                    ? (className && className.indexOf('col-12') === -1) || (className && className.indexOf('col-12') !== -1 && className.indexOf('col-md-') !== -1)
                        ? 'form-field-title col-12 col-md-5 text-left text-md-right pb-2 pb-md-0 pr-md-0'
                        : 'form-field-title col-12 col-md-3 text-left text-md-right pb-2 pb-md-0'
                    : 'form-field-title col-12'}>{titleWithoutTranslate ? title : trb(title)}</div>}
            <div className={classNameField
                ? 'form-field-item ' + classNameField
                : FormFieldInputWrapperClasses(meta.error, meta.submitError, meta.touched, inline, className)}>
                <Select
                    allowClear
                    showSearch
                    placeholder={trb(placeholder)}
                    disabled={disabled}
                    name={this.props.input.name}
                    value={checkOption(this.props.input.value, this.props.input)}
                    onChange={this.onValueChange}
                    onSelect={this.onSelect}
                    onSearch={this.onSearch}
                    filterOption={(input, option) => option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    onBlur={this.onBlur}
                    onClear={this.onClear}
                    getPopupContainer={() => document.getElementById('card')}
                >
                    {options && options.map((item, index) =>
                        <Option value={item[optionsValue]} key={index}>{translate ? trb(translate + item[optionsLabel]) : item[optionsLabel]}</Option>
                    )}
                </Select>
            </div>
            <div className={classNameError
                ? 'form-field-error ' + classNameError
                : inline ? 'form-field-error col-12 text-right' : 'form-field-error col-12 text-right'}>{meta.touched && (meta.error || meta.submitError)}</div>
        </div>
    }
};

